module.exports = "/src/views/player/help/images/azart4.jpg";